import { Component, OnInit } from '@angular/core';
import { Routes, Router } from '@angular/router';


import { Http } from '@angular/http';
import { AuthHttp, tokenNotExpired } from 'angular2-jwt';
import { TranslateService } from '@ngx-translate/core';

import { BaMenuService } from '../theme';
import { BaPageTopComponent } from '../theme/components/baPageTop';
import { PAGES_MENU_ADMIN } from './pages.menu.admin';
import { PAGES_MENU_ALL } from './pages.menu.all';
import { PAGES_MENU_USER } from './pages.menu.user';
import { PAGES_MENU_FREELANCER } from './pages.menu.freelancer';
import { PAGES_MENU_CONTRACT } from './pages.menu.contract';
import { PAGES_MENU_CHECKDOC } from './pages.menu.checkdoc';

import { Message } from 'primeng/primeng';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit {
    currentLang: string;
    public msgs: Message[] = [];
    public ImgPerfile: string;

    constructor(
        private _menuService: BaMenuService,
        private translate: TranslateService,
        public router: Router
        // public baPageTop: BaPageTop,
        // public accountComponent: AccountComponent,
        ) {
            this.currentLang = 'es';
            translate.setDefaultLang(this.currentLang);
            translate.use(this.currentLang);
    }

    public getAccount() {
    }

    public changeLanguage(lang) {
    }

    ngOnInit() {
        this.getAccount();
        const role = localStorage.getItem('role');
        switch (role) {
          case 'admin':
            this._menuService.updateMenuByRoutes(<Routes> PAGES_MENU_ADMIN);
          break;
          case 'user':
            this._menuService.updateMenuByRoutes(<Routes> PAGES_MENU_USER);
          break;
          case 'docchecker':
            this._menuService.updateMenuByRoutes(<Routes> PAGES_MENU_CHECKDOC);
          break;
          case 'contracts':
            this._menuService.updateMenuByRoutes(<Routes> PAGES_MENU_CONTRACT);
          break;
          case 'freelancer':
            this._menuService.updateMenuByRoutes(<Routes> PAGES_MENU_FREELANCER);
          break;
          case 'all':
            this._menuService.updateMenuByRoutes(<Routes> PAGES_MENU_ALL);
          break;

          default:
            this._menuService.updateMenuByRoutes(<Routes> PAGES_MENU_USER);
          break;
        }

    }

    public showVersion() {
        const version = '1.0.3 alpha';
        console.log (version);
        this.msgs = [];
        this.msgs.push( { severity: 'info', summary: version } );
    }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/pages.component.ts